<template>
  <div v-if="offer" class="dialog">
    <Spinner v-if="messagesLoading" size="large" class="messages-loading" />
    <div v-else-if="isMessages" id="messages" class="messages-container spacey-20">
      <div v-for="(message, idx) in messagesByDays" :key="idx">
        <div class="message-date">
          {{ message[0] }}
        </div>
        <div class="messages spacey-20">
          <Message
            v-for="message in message[1]"
            :key="message.id"
            :user-id="user.id"
            :message="message"
            @delete="deleteMessage(message.id)"
            @resend="resendMessage(message)"
          />
        </div>
      </div>
      <div style="height: 50px"></div>
    </div>

    <Info
      v-else
      class="chat-info"
      :title="$t('No messages yet')"
      :text="
        $t(
          `Here’s your chat with company. You can discuss prices, offers, suggestions, attach files etc.`
        )
      "
    />
    <!--    TODO: отображение кол-ва непрочитанных-->
    <!--    <div v-if="unreadMessagesCount" class="unread-messages">-->
    <!--      <button type="button" class="unread-messages__navigation" @click="scrollAndRead">-->
    <!--        <Icon type="chevron-down" size="16" />-->
    <!--      </button>-->
    <!--      <Badge class="unread-messages__counter" color="accent" rounded>{{-->
    <!--        unreadMessagesCount-->
    <!--      }}</Badge>-->
    <!--    </div>-->
    <div class="message-and-files">
      <form class="message__form spacex-6" @submit.prevent="sendMessage">
        <FileUpload class="message__attach-files" @select="uploadFiles">
          <Icon size="16" type="paperclip" />
        </FileUpload>
        <Badge v-if="files.length" rounded>{{ files.length }}</Badge>

        <input ref="file-input" class="file-input" type="text" />
        <input
          v-model="message"
          class="message__input"
          type="text"
          :placeholder="$t('Write a message...')"
        />
        <IconButton
          v-if="isPossibleToSend"
          :height="15"
          type="submit"
          :icon="sendButton"
          class="message__send-button"
        />
      </form>
    </div>
  </div>
</template>

<script>
  import FileUpload from '@/components/ui/FileUpload';
  import IconButton from '@/components/ui/IconButton';
  import Send from '@/assets/icons/send.svg';
  import offerMessagesSubscription from '@/gql/projects/offer-messages-subscription.graphql';
  import Message from '@/components/chat/Message';
  import { mapState } from 'vuex';
  import request from '@/utils/api/request';
  import get from 'lodash.get';
  import axios from 'axios';
  import Info from '@/components/chat/Info';
  import factory from '@/utils/api/factory';
  import Icon from '@/components/ui/Icon';
  import Badge from '@/components/ui/Badge';
  import Spinner from '@/components/ui/Spinner';

  export default {
    name: 'Dialog',
    components: {
      FileUpload,
      IconButton,
      Message,
      Info,
      Icon,
      Badge,
      Spinner,
    },
    props: {
      offer: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        sendButton: Send,
        files: [],
        fileIds: [],
        message: '',
        lastIdx: 1,
        fileIdx: 1,
        allMessages: [],
        messagesLoading: true,
        isFirstUpdate: true,
      };
    },
    updated() {
      if (this.isFirstUpdate) {
        this.scrollToEnd();
        this.isFirstUpdate = false;
      }
    },
    apollo: {
      $subscribe: {
        messages() {
          return {
            query: offerMessagesSubscription,
            variables: {
              id: this.offerId,
            },
            result({ data }) {
              this.allMessages = get(data, 'messages', []).map((message) => {
                if (message.tender_offer_row_comment) {
                  return {
                    ...message,
                    message: message.tender_offer_row_comment.text,
                  };
                } else return message;
              });

              this.messagesLoading = false;
              if (this.allMessages.length)
                this.readMessages(this.allMessages[this.allMessages.length - 1].id);
            },
          };
        },
      },
    },
    computed: {
      ...mapState('auth', ['user']),
      unreadMessagesCount() {
        return this.offer.unread_messages_count;
      },
      offerId() {
        return this.offer.id;
      },
      isPossibleToSend() {
        return (
          this.message.length || (this.files.length && !this.files.some((file) => file.uploading))
        );
      },
      isMessages() {
        return !!this.allMessages.length;
      },
      messagesByDays() {
        let lastDate = null;
        let messagesByDate = [];
        let messages = [];
        this.allMessages.forEach((message) => {
          let date = new Date(message.updated_at);
          if (
            lastDate === null ||
            lastDate.getDate() !== date.getDate() ||
            lastDate.getMonth() !== lastDate.getMonth()
          ) {
            if (lastDate) messagesByDate.push([this.getDate(lastDate), messages]);
            messages = [message];
            lastDate = date;
          } else {
            messages.push(message);
          }
        });
        if (messages.length) messagesByDate.push([this.getDate(lastDate), messages]);
        return messagesByDate || [];
      },
    },
    methods: {
      scrollAndRead() {
        this.scrollToEnd();
      },
      deleteMessage(messageId) {
        this.allMessages = this.allMessages.filter((message) => message.id !== messageId);
      },
      resendMessage(message) {
        try {
          request(message.request);
        } catch (e) {
          console.error('resend message', e);
        }
      },
      getDate(date) {
        return date.toLocaleDateString(undefined, {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        });
      },
      async sendMessage() {
        let id = this.lastIdx++;

        let newMessage = {
          id: `${id}-my`,
          message: this.message,
          files: this.files,
          updated_at: new Date().toISOString(),
          user: {
            id: this.user.id,
          },
          loading: true,
        };

        try {
          this.allMessages.push(newMessage);

          await request.post('/tender_messages/', {
            tender_offer_id: this.offerId,
            message: this.message,
            file_ids: this.files.map((file) => file.id),
          });

          this.clearForm();
          this.scrollToEnd();
        } catch (e) {
          this.clearForm();
          newMessage.request = e.response.config;
          newMessage.loading = false;
          newMessage.error = true;
        }
      },
      uploadFiles(files) {
        files.forEach(this.uploadFile);
      },
      async uploadFile(file) {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        let newFile = {
          file,
          name: file?.name || null,
          source,
          uploading: true,
          percent: 0,
          fileIdx: this.fileIdx++,
          id: 0,
        };

        const config = {
          onUploadProgress: (event) => {
            newFile.percent = Math.round((event.loaded * 100) / event.total);
          },
          cancelToken: source.token,
        };

        this.files.push(newFile);

        try {
          let fd = new FormData();
          fd.set('file', file);

          let { data } = await request.post('/tender_messages/file/', fd, config);

          newFile.id = data.id;
          newFile.file = data.file;
          this.$refs['file-input'].focus();
        } catch (e) {
          this.files = this.files.filter((file) => file.id !== newFile.id);
        }

        newFile.uploading = false;
      },
      deleteFile(idx) {
        this.files.splice(idx, 1);
      },
      clearForm() {
        this.files = [];
        this.message = '';
      },
      scrollToEnd() {
        let container = this.$el.querySelector('#messages');
        if (container) container.scrollTop = container.scrollHeight;
      },
      async readMessages(lastMessageId) {
        try {
          await factory('tender_messages').postInResourcePath(lastMessageId, 'mark_as_read');
        } catch (e) {
          console.error(e);
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .message__form {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 44px;

    background: white;
    box-shadow: 0 8px 32px rgba(31, 45, 63, 0.1);
    border-radius: 40px;
  }

  .message-and-files {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    padding: 16px 16px 20px 16px;
  }

  .unread-messages {
    position: absolute;
    right: 16px;
    bottom: 86px;
    &__counter {
      position: absolute;
      right: 0;
      top: 20px;
    }
    &__navigation {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 6px;

      width: 32px;
      height: 32px;

      background: #ffffff;

      border: 1px solid #dadde2;
      box-sizing: border-box;
      border-radius: 99px;

      &:hover {
        background-color: $surface2;
      }
    }
  }

  .message__input {
    padding: 12px 0;
    color: $grey900;
    font-weight: normal;
    font-size: 14px;

    &::placeholder {
      color: $text-secondary;
      font-weight: 500;
      font-size: 14px;
      line-height: 140%;
    }
  }

  .messages-container {
    padding: 20px;

    overflow: auto;
    height: calc(100% - 40px);
    position: absolute;
    top: 40px;
    width: 100%;
  }

  .message-date {
    text-align: center;
    color: $grey700;
    font-size: 14px;
    padding: 4px 8px;

    margin-bottom: 8px;
  }

  .message__attach-files {
    display: flex;
    cursor: pointer;
    padding-left: 14px;

    &:hover {
      .attach-files__icon path {
        fill: $grey600;
      }
    }
  }

  .attach-files__icon {
    height: 12px;
  }

  .files-container {
    background-color: #ffffff7a;
    padding: 12px;
    display: flex;
    margin-bottom: -4px;
    flex-wrap: wrap;
  }

  .chat-info {
    z-index: 1;
    position: absolute;
    top: 50%;
    margin: -50px 20px auto 20px;
  }

  .attached-file {
    margin: 0 4px 4px 0;

    width: 130px;
    height: 32px;
  }

  .message__send-button {
    padding: 12px 20px 12px 12px;
  }

  .file-input {
    width: 0;
    border: none;
    height: 0;
  }

  .messages-loading {
    right: 50%;
    bottom: 50%;
    position: absolute;
  }
</style>
